import { SvgIcon } from '../../../../common/components/SvgIcon';
import type { ITranslatorProps } from '../../../../common/sgwt-i18n';
import type { HELPCENTER_QUIT, ISgwtHelpCenterAction } from '../../sgwt-help-center.types';

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'sgwt-chatbot': {
        id?: string;
      };
    }
  }
}

interface WebChatProps extends ITranslatorProps {
  chatContext?: string;
  domain?: string;
  random?: string;
  quit: HELPCENTER_QUIT;
  cancelChat: () => void;
  close: () => void;
  next: (action: ISgwtHelpCenterAction) => void;
  previous: (nb?: number) => void;
}

export const WebChat = (props: WebChatProps) => {
  const { cancelChat, close, previous, quit = '', translator } = props;
  return (
    <div className={`d-flex h-100 ${props.quit ? '' : 'flex-column'}`}>
      {props.quit ? (
        <div className="align-self-center">
          <i className="icon bg-warning-alpha-md text-warning display-3 mb-3 p-1" style={{ borderRadius: '50%' }} aria-hidden="true">
            <SvgIcon type="warning" className="mt-n2" />
          </i>
          <p className="mb-0 text-warning display-5">{translator.translate('chatExitMessage')}</p>
          <p className="mt-4">
            <button className="btn btn-outline-primary btn-lg btn-block" type="button" onClick={cancelChat}>
              {translator.translate('chatExitCancelButton')}
            </button>
            <button
              className="btn btn-danger btn-lg btn-block mt-2"
              type="button"
              onClick={() => {
                if (quit === 'close') {
                  close();
                } else {
                  previous();
                }
              }}
            >
              {translator.translate('chatExitOkButton')}
            </button>
          </p>
        </div>
      ) : (
        <div className="panel-chat-header text-secondary mb-1">{props.translator.translate('chatInformationMessage')}</div>
      )}
      <div className={quit ? 'd-none' : 'h-100 border'}>
        <sgwt-chatbot />
      </div>
    </div>
  );
};
